// src/components/CountdownTimer.js
import React, { useState, useEffect } from 'react';

const CountdownTimer = () => {
    const calculateTimeLeft = () => {
        const now = new Date();
        const tomorrow = new Date(now);
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0); // Set to midnight

        const difference = tomorrow - now;

        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24).toString().padStart(2, '0'),
                minutes: Math.floor((difference / 1000 / 60) % 60).toString().padStart(2, '0'),
                seconds: Math.floor((difference / 1000) % 60).toString().padStart(2, '0'),
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        // Cleanup the interval on component unmount
        return () => clearInterval(timer);
    }, []);

    return (
        <div className="text-center">
            <h3 className="text-sm font-bold tracking-widest uppercase text-gray-500 dark:text-gray-400">
                NEXT PUZZLE IN
            </h3>
            <p className="font-mono text-2xl font-bold">
                {timeLeft.hours}:{timeLeft.minutes}:{timeLeft.seconds}
            </p>
        </div>
    );
};

export default CountdownTimer;
